export default {
  GET_PatientUsers: [],
};
